import { CardDefectComponent } from "../layouts/dashboard/test-report-summarization/card-defect/card-defect.component";
import { HotspotSummaryComponent } from "../layouts/dashboard/test-report-summarization/hotspot-summary/hotspot-summary.component";
import { RiskIndicationComponent } from "../layouts/dashboard/test-report-summarization/risk-indication/risk-indication.component";
import { TestCaseSummaryComponent } from "../layouts/dashboard/test-report-summarization/test-case-summary/test-case-summary.component";
import { UserStoryDetailsComponent } from "../layouts/dashboard/test-report-summarization/user-story-details/user-story-details.component";
import { RecommendationCodeSnippetComponent } from "../layouts/workflow/code-mappings/recommendations/recommendation-code-snippet/recommendation-code-snippet.component";
import { ApplicationHospotTableComponent } from "./application-hospot-table/application-hospot-table.component";
import { CardSummaryComponent } from "./card-summary/card-summary.component";
import { CardTileComponent } from "./card-tile/card-tile.component";
import { BarChartComponent } from "./chart/bar-chart/bar-chart.component";
import { BarLineChartComponent } from "./chart/bar-line-chart/bar-line-chart.component";
import { GroupedBarChartComponent } from "./chart/grouped-bar-chart/grouped-bar-chart.component";
import { LineChartComponent } from "./chart/line-chart/line-chart.component";
import { MindMapComponent } from "./chart/mind-map/mind-map.component";
import { MultiLineChartComponent } from "./chart/multi-line-chart/multi-line-chart.component";
import { PieChartComponent } from "./chart/pie-chart/pie-chart.component";
import { AccordionTableViewComponent } from "./common/accordion-table-view/accordion-table-view.component";
import { AccordionComponent } from "./common/accordion/accordion.component";
import { CodeSnippetComponent } from "./common/code-snippet/code-snippet.component";
import { CommonListComponent } from "./common/common-list/common-list.component";
import { ZorroTableTetcaseGeneratorComponent } from "./common/custom-table-testcase-generator/zorro-table-tetcase-generator/zorro-table-tetcase-generator.component";
import { ZorroTableComponent } from "./common/custom-table/zorro-table.component";
import { DragNDropComponent } from "./common/drag-n-drop/drag-n-drop.component";
import { DropdownWithSectionsComponent } from "./common/dropdown-with-sections/dropdown-with-sections.component";
import { ExpandableDetailedViewComponent } from "./common/expandable-detailed-view/expandable-detailed-view.component";
import { ExpandableTableComponent } from "./common/expandable-table/expandable-table.component";
import { ExpansionPanelViewComponent } from "./common/expansion-panel-view/expansion-panel-view.component";
import { IconComponent } from "./common/icon/icon.component";
import { LoadingComponent } from "./common/loading/loading.component";
import { MultiSegmentProgressBarComponent } from "./common/multi-segment-progress-bar/multi-segment-progress-bar.component";
import { NoDataComponent } from "./common/no-data/no-data.component";
import { ProgressBarComponent } from "./common/progress-bar/progress-bar.component";
import { StepperComponent } from "./common/stepper/stepper.component";
import { TabComponent } from "./common/tab/tab.component";
import { TableViewComponent } from "./common/table-view/table-view.component";
import { TestCasePerformanceViewComponent } from "./common/test-case-performance-view/test-case-performance-view.component";
import { ExecutionCycleViewComponent } from "./execution-results-view/execution-cycle-view/execution-cycle-view.component";
import { ExecutionOverviewViewComponent } from "./execution-results-view/execution-overview-view/execution-overview-view.component";
import { FilterPanelComponent } from "./filter-panel/filter-panel.component";
import { HeaderComponent } from "./header/header.component";
import { KeyValueCardComponent } from "./key-value-card/key-value-card.component";
import { MetricCardViewComponent } from "./metric-card-view/metric-card-view.component";
import { ScriptCardTileComponent } from "./script-card-tile/script-card-tile.component";
import { SideNavContentComponent } from "./side-nav-content/side-nav-content.component";
import { SideNavItemComponent } from "./side-nav/side-nav-item/side-nav-item.component";
import { SideNavComponent } from "./side-nav/side-nav.component";
import { TestReviewComponent } from "./smart-test-review/test-review/test-review.component";
import { SummaryDataCardComponent } from "./summary-data-card/summary-data-card.component";
import { TableWithHeaderComponent } from "./table-with-header/table-with-header.component";
import { GeneratedTestCasesComponent } from "./test-case-generator/generated-test-cases/generated-test-cases.component";
import { TestCaseVersionComponent } from "./test-case-generator/test-case-version/test-case-version.component";
import { UserStoriesComponent } from "./test-case-generator/user-stories/user-stories.component";
import { TreeViewComponent } from "./tree-view/tree-view.component";
import { AssetUrlPipe } from "../core/pipes/asset-url.pipe";
import { MarkdownPipe } from "../core/pipes/markdown.pipe";

export const SharedPipes = [AssetUrlPipe, MarkdownPipe];

/**
 * This component contains the Shared Components in the app
 */
export const SharedComponents = [
  HeaderComponent,
  SideNavComponent,
  CardTileComponent,
  CardTileComponent,
  SideNavItemComponent,
  SideNavContentComponent,
  MetricCardViewComponent,
  NoDataComponent,
  IconComponent,
  TableViewComponent,
  CardSummaryComponent,
  LineChartComponent,
  MindMapComponent,
  BarChartComponent,
  PieChartComponent,
  ExpansionPanelViewComponent,
  TabComponent,
  CommonListComponent,
  UserStoriesComponent,
  TestCaseVersionComponent,
  GeneratedTestCasesComponent,
  ApplicationHospotTableComponent,
  BarLineChartComponent,
  BarLineChartComponent,
  CodeSnippetComponent,
  RecommendationCodeSnippetComponent,
  StepperComponent,
  TestReviewComponent,
  KeyValueCardComponent,
  LoadingComponent,
  ZorroTableComponent,
  AccordionComponent,
  DragNDropComponent,
  SummaryDataCardComponent,
  ProgressBarComponent,
  TreeViewComponent,
  ScriptCardTileComponent,
  ExpandableTableComponent,
  DropdownWithSectionsComponent,
  ZorroTableTetcaseGeneratorComponent,
  RiskIndicationComponent,
  HotspotSummaryComponent,
  CardDefectComponent,
  TestCaseSummaryComponent,
  UserStoryDetailsComponent,
  AccordionTableViewComponent,
  TableWithHeaderComponent,
  MultiSegmentProgressBarComponent,
  ExecutionCycleViewComponent,
  ExecutionOverviewViewComponent,
  ExpandableDetailedViewComponent,
  TestCasePerformanceViewComponent,
  GroupedBarChartComponent,
  MultiLineChartComponent,
  FilterPanelComponent
];

/** Shared standalone imports for feature modules (components + asset URL pipe). */
export const SharedImports = [...SharedComponents, ...SharedPipes];
